var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState } from 'react';
import { updateMedicationDaaDosageInstruction, updateMedicationDosageTimesOrderInstruction, updateMedicationFreeTextDosageInstruction, updateMedicationFreeTextOrderInstruction } from '../../../Async/MedicationsSummaryAsync';
import { displayMessage } from '../../../Config/ApplicationConfig';
import { InstructionType, MedicationType } from '../../../Contracts/MedicationModels';
import { isDaaInstruction, isDosageTimesInstruction, isFreeTextInstruction } from '../../../Contracts/PatientMedication.Response';
import { ValidDateFormats } from '../../../Shared/DateUtilities';
import { DaaRequired } from '../DaaSelectorField';
import moment from 'moment-timezone';
function convertDaaFormStateToClientState(form) {
    return {
        type: InstructionType.DaaInstruction,
        additionalInstructions: form.additionalInstructions,
        breakfast: isNaN(Number(form.breakfast)) ? 0 : Number(form.breakfast),
        dinner: isNaN(Number(form.dinner)) ? 0 : Number(form.dinner),
        lunch: isNaN(Number(form.lunch)) ? 0 : Number(form.lunch),
        nightTime: isNaN(Number(form.night)) ? 0 : Number(form.night),
        packagingType: form.packagingType,
        routeOfAdministration: null,
        instructions: '',
        textInstructions: ''
    };
}
function convertFreeTextFormStateToClientState(form) {
    return {
        type: InstructionType.FreeTextInstruction,
        instructions: form.instructions,
        routeOfAdministration: form.routeOfAdministration,
        textInstructions: ''
    };
}
function convertDosageTimesFormStateToClientState(form) {
    var _a, _b;
    return {
        type: InstructionType.DosageTimeInstruction,
        instructions: form.instructions,
        routeOfAdministration: form.routeOfAdministration,
        frequency: (_a = form.frequency) !== null && _a !== void 0 ? _a : null,
        times: (_b = form.times) !== null && _b !== void 0 ? _b : [],
        startsOn: form.startsOn && form.startsOn.isValid()
            ? moment(form.startsOn).format(ValidDateFormats.NodeDateTimezone)
            : moment().format(ValidDateFormats.NodeDateTimezone),
        textInstructions: ''
    };
}
export function daaInstructionContractToForm(instruction) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (isDaaInstruction(instruction)) {
        return {
            additionalInstructions: (_a = instruction.additionalInstructions) !== null && _a !== void 0 ? _a : '',
            breakfast: (_c = (_b = instruction.breakfast) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '0',
            dinner: (_e = (_d = instruction.dinner) === null || _d === void 0 ? void 0 : _d.toString()) !== null && _e !== void 0 ? _e : '0',
            lunch: (_g = (_f = instruction.lunch) === null || _f === void 0 ? void 0 : _f.toString()) !== null && _g !== void 0 ? _g : '0',
            night: (_j = (_h = instruction.nightTime) === null || _h === void 0 ? void 0 : _h.toString()) !== null && _j !== void 0 ? _j : '0',
            packagingType: (_k = instruction.packagingType) !== null && _k !== void 0 ? _k : null
        };
    }
    return {
        additionalInstructions: '',
        breakfast: '',
        dinner: '',
        lunch: '',
        night: '',
        packagingType: null
    };
}
export function freeTextInstructionContractToForm(instruction) {
    if (isFreeTextInstruction(instruction)) {
        return {
            type: InstructionType.FreeTextInstruction,
            instructions: instruction.instructions,
            routeOfAdministration: instruction.routeOfAdministration
        };
    }
    return {
        type: InstructionType.FreeTextInstruction,
        instructions: '',
        routeOfAdministration: null
    };
}
export function dosageTimesInstructionContractToForm(instruction) {
    var _a, _b;
    if (isDosageTimesInstruction(instruction)) {
        return {
            type: InstructionType.DosageTimeInstruction,
            instructions: instruction.instructions,
            routeOfAdministration: instruction.routeOfAdministration,
            frequency: instruction.frequency,
            times: (_b = (_a = instruction.times) === null || _a === void 0 ? void 0 : _a.map(function (time) { return [time.split(':')[0], time.split(':')[1]].join(':'); })) !== null && _b !== void 0 ? _b : [],
            startsOn: instruction.startsOn ? moment(instruction.startsOn, ValidDateFormats.NodeDateTimezone) : null
        };
    }
    return {
        type: InstructionType.DosageTimeInstruction,
        instructions: '',
        routeOfAdministration: null,
        frequency: null,
        times: [],
        startsOn: null
    };
}
export var SameInstructions;
(function (SameInstructions) {
    SameInstructions["Same"] = "same";
    SameInstructions["NotSame"] = "notSame";
})(SameInstructions || (SameInstructions = {}));
export function useDosageInstructionState(props) {
    var _this = this;
    var _a = __read(useState(function () {
        var _a, _b;
        if (isFreeTextInstruction(props.patient.dosageInstruction) &&
            (isFreeTextInstruction(props.patient.orderInstruction) ||
                isDosageTimesInstruction(props.patient.orderInstruction))) {
            if (props.patient.dosageInstruction.instructions !== props.patient.orderInstruction.instructions ||
                ((_a = props.patient.dosageInstruction.routeOfAdministration) === null || _a === void 0 ? void 0 : _a.code) !==
                    ((_b = props.patient.orderInstruction.routeOfAdministration) === null || _b === void 0 ? void 0 : _b.code))
                return SameInstructions.NotSame;
        }
        return SameInstructions.Same;
    }), 2), orderSameAsDosage = _a[0], setOrderSameAsDosage = _a[1];
    var _b = __read(useState(function () {
        if (isDaaInstruction(props.patient.dosageInstruction))
            return daaInstructionContractToForm(props.patient.dosageInstruction);
        return {
            additionalInstructions: '',
            breakfast: '0',
            dinner: '0',
            lunch: '0',
            night: '0',
            packagingType: null
        };
    }), 2), dosageDaaState = _b[0], setDosageDaaState = _b[1];
    var _c = __read(useState(function () {
        if (isFreeTextInstruction(props.patient.dosageInstruction))
            return freeTextInstructionContractToForm(props.patient.dosageInstruction);
        return {
            type: InstructionType.FreeTextInstruction,
            instructions: '',
            routeOfAdministration: null
        };
    }), 2), dosageFreeTextState = _c[0], setDosageFreeTextState = _c[1];
    var _d = __read(useState(function () {
        if (isFreeTextInstruction(props.patient.orderInstruction))
            return freeTextInstructionContractToForm(props.patient.orderInstruction);
        if (isDosageTimesInstruction(props.patient.orderInstruction))
            return dosageTimesInstructionContractToForm(props.patient.orderInstruction);
        return {
            type: InstructionType.DosageTimeInstruction,
            instructions: '',
            routeOfAdministration: null,
            frequency: null,
            times: [],
            startsOn: null
        };
    }), 2), orderState = _d[0], setOrderState = _d[1];
    var changeOrder = function (form) { return __awaiter(_this, void 0, void 0, function () {
        var orderInstructionClientState, newDosageInstructions, e_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setOrderState(form);
                    orderInstructionClientState = isFreeTextInstruction(form)
                        ? convertFreeTextFormStateToClientState(form)
                        : convertDosageTimesFormStateToClientState(form);
                    newDosageInstructions = orderSameAsDosage === SameInstructions.Same
                        ? orderInstructionClientState
                        : convertFreeTextFormStateToClientState(dosageFreeTextState);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, , 5]);
                    if (!(newDosageInstructions.instructions !== dosageFreeTextState.instructions ||
                        ((_a = newDosageInstructions.routeOfAdministration) === null || _a === void 0 ? void 0 : _a.code) !== ((_b = dosageFreeTextState.routeOfAdministration) === null || _b === void 0 ? void 0 : _b.code))) return [3 /*break*/, 3];
                    setDosageFreeTextState({
                        instructions: newDosageInstructions.instructions,
                        routeOfAdministration: newDosageInstructions.routeOfAdministration,
                        type: InstructionType.FreeTextInstruction
                    });
                    return [4 /*yield*/, updateMedicationFreeTextDosageInstruction(props.patient.id, newDosageInstructions)];
                case 2:
                    _c.sent();
                    _c.label = 3;
                case 3:
                    props.onUpdate(__assign(__assign({}, props.patient), { orderInstruction: orderInstructionClientState, dosageInstruction: newDosageInstructions }));
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _c.sent();
                    console.error('Unable to update dosage instructions');
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var changeDosageSameAsOrder = function (same) { return __awaiter(_this, void 0, void 0, function () {
        var freeTextInstruction, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setOrderSameAsDosage(same);
                    if (same === SameInstructions.Same) {
                        setDosageFreeTextState({
                            instructions: orderState.instructions,
                            routeOfAdministration: orderState.routeOfAdministration,
                            type: InstructionType.FreeTextInstruction
                        });
                    }
                    freeTextInstruction = convertFreeTextFormStateToClientState(orderState);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateMedicationFreeTextDosageInstruction(props.patient.id, freeTextInstruction)];
                case 2:
                    _a.sent();
                    props.onUpdate(__assign(__assign({}, props.patient), { dosageInstruction: freeTextInstruction }));
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _a.sent();
                    console.error('Unable to update dosage instructions');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var changeDosageDaa = function (form) {
        setDosageDaaState(form);
        props.onUpdate(__assign(__assign({}, props.patient), { dosageInstruction: convertDaaFormStateToClientState(form) }));
    };
    var changeDosageFreeText = function (form) {
        setDosageFreeTextState(form);
        props.onUpdate(__assign(__assign({}, props.patient), { dosageInstruction: convertFreeTextFormStateToClientState(form) }));
    };
    var changeMedicationType = function (type) { return __awaiter(_this, void 0, void 0, function () {
        var dosageInstruction, err_1, orderInstruction, err_2, dosageInstruction, err_3, dosageTimesInstructionFormStructure, orderInstruction, dosageInstruction, newDosageFreeText, err_4;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(type === MedicationType.TakeHomeScript)) return [3 /*break*/, 5];
                    dosageInstruction = convertFreeTextFormStateToClientState(dosageFreeTextState);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateMedicationFreeTextDosageInstruction(props.patient.id, dosageInstruction)];
                case 2:
                    _c.sent();
                    props.onUpdate(__assign(__assign({}, props.patient), { dosageInstruction: __assign({}, dosageInstruction) }));
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _c.sent();
                    console.error('Unable to update dosage instructions');
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 19];
                case 5:
                    if (!(type === MedicationType.MedicationOrder)) return [3 /*break*/, 10];
                    orderInstruction = convertFreeTextFormStateToClientState(orderState);
                    _c.label = 6;
                case 6:
                    _c.trys.push([6, 8, , 9]);
                    return [4 /*yield*/, Promise.all([
                            updateMedicationFreeTextOrderInstruction(props.patient.id, orderInstruction),
                            updateMedicationFreeTextDosageInstruction(props.patient.id, orderInstruction)
                        ])];
                case 7:
                    _c.sent();
                    setOrderSameAsDosage(SameInstructions.Same);
                    props.onUpdate(__assign(__assign({}, props.patient), { orderInstruction: __assign({}, orderInstruction), dosageInstruction: __assign({}, orderInstruction) }));
                    return [3 /*break*/, 9];
                case 8:
                    err_2 = _c.sent();
                    console.error('Unable to update dosage instructions');
                    return [3 /*break*/, 9];
                case 9: return [3 /*break*/, 19];
                case 10:
                    if (!(type === MedicationType.MedicationHistory)) return [3 /*break*/, 15];
                    dosageInstruction = convertFreeTextFormStateToClientState(dosageFreeTextState);
                    _c.label = 11;
                case 11:
                    _c.trys.push([11, 13, , 14]);
                    return [4 /*yield*/, updateMedicationFreeTextDosageInstruction(props.patient.id, dosageInstruction)];
                case 12:
                    _c.sent();
                    props.onUpdate(__assign(__assign({}, props.patient), { dosageInstruction: __assign({}, dosageInstruction) }));
                    return [3 /*break*/, 14];
                case 13:
                    err_3 = _c.sent();
                    console.error('Unable to update dosage instructions');
                    return [3 /*break*/, 14];
                case 14: return [3 /*break*/, 19];
                case 15:
                    if (!(type === MedicationType.EnrmcScript)) return [3 /*break*/, 19];
                    dosageTimesInstructionFormStructure = void 0;
                    // If order instruction == dosage time
                    if (orderState.type === InstructionType.DosageTimeInstruction) {
                        // The new order instruction state = existing
                        dosageTimesInstructionFormStructure = orderState;
                    }
                    else {
                        // otherwise set it to nothing
                        dosageTimesInstructionFormStructure = {
                            type: InstructionType.DosageTimeInstruction,
                            instructions: orderState.instructions,
                            routeOfAdministration: orderState.routeOfAdministration,
                            frequency: null,
                            times: [],
                            startsOn: null
                        };
                        setOrderState(dosageTimesInstructionFormStructure);
                    }
                    orderInstruction = convertDosageTimesFormStateToClientState(dosageTimesInstructionFormStructure);
                    dosageInstruction = void 0;
                    // If dosage and order are the same
                    // and order instruction !== dosage instruction
                    if (orderSameAsDosage === SameInstructions.Same &&
                        (orderInstruction.instructions !== dosageFreeTextState.instructions ||
                            ((_a = orderInstruction.routeOfAdministration) === null || _a === void 0 ? void 0 : _a.code) !== ((_b = dosageFreeTextState.routeOfAdministration) === null || _b === void 0 ? void 0 : _b.code))) {
                        newDosageFreeText = {
                            instructions: orderInstruction.instructions,
                            routeOfAdministration: orderInstruction.routeOfAdministration,
                            type: InstructionType.FreeTextInstruction
                        };
                        // Reset dosage instruction to free text
                        setDosageFreeTextState(newDosageFreeText);
                        dosageInstruction = convertFreeTextFormStateToClientState(newDosageFreeText);
                    }
                    else {
                        dosageInstruction = convertFreeTextFormStateToClientState(dosageFreeTextState);
                    }
                    _c.label = 16;
                case 16:
                    _c.trys.push([16, 18, , 19]);
                    return [4 /*yield*/, Promise.all([
                            updateMedicationDosageTimesOrderInstruction(props.patient.id, orderInstruction),
                            updateMedicationFreeTextDosageInstruction(props.patient.id, dosageInstruction)
                        ])];
                case 17:
                    _c.sent();
                    props.onUpdate(__assign(__assign({}, props.patient), { orderInstruction: __assign({}, orderInstruction), dosageInstruction: __assign({}, dosageInstruction) }));
                    return [3 /*break*/, 19];
                case 18:
                    err_4 = _c.sent();
                    console.error('Unable to update dosage instructions');
                    return [3 /*break*/, 19];
                case 19: return [2 /*return*/];
            }
        });
    }); };
    var changeDaaRequired = function (type) { return __awaiter(_this, void 0, void 0, function () {
        var daaInstruction, err_5, freeTextInstruction, err_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(type === DaaRequired.Yes)) return [3 /*break*/, 5];
                    daaInstruction = convertDaaFormStateToClientState(dosageDaaState);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    props.onUpdate(__assign(__assign({}, props.patient), { dosageInstruction: daaInstruction }));
                    return [4 /*yield*/, updateMedicationDaaDosageInstruction(props.patient.id, daaInstruction)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_5 = _a.sent();
                    displayMessage('Unable to update dosage instructions');
                    props.onUpdate(__assign(__assign({}, props.patient), { dosageInstruction: convertFreeTextFormStateToClientState(dosageFreeTextState) }));
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 9];
                case 5:
                    freeTextInstruction = convertFreeTextFormStateToClientState(dosageFreeTextState);
                    _a.label = 6;
                case 6:
                    _a.trys.push([6, 8, , 9]);
                    props.onUpdate(__assign(__assign({}, props.patient), { dosageInstruction: freeTextInstruction }));
                    return [4 /*yield*/, updateMedicationFreeTextDosageInstruction(props.patient.id, freeTextInstruction)];
                case 7:
                    _a.sent();
                    return [3 /*break*/, 9];
                case 8:
                    err_6 = _a.sent();
                    displayMessage('Unable to update dosage instructions');
                    props.onUpdate(__assign(__assign({}, props.patient), { dosageInstruction: convertDaaFormStateToClientState(dosageDaaState) }));
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    return {
        orderSameAsDosage: orderSameAsDosage,
        changeDaaRequired: changeDaaRequired,
        changeMedicationType: changeMedicationType,
        changeDosageSameAsOrder: changeDosageSameAsOrder,
        changeDosageDaa: changeDosageDaa,
        changeDosageFreeText: changeDosageFreeText,
        changeOrder: changeOrder
    };
}
